import { createContext, useContext, useState } from 'react'

const SEASONS = ['2026', '2027'] as const
export type Season = typeof SEASONS[number]

const SeasonContext = createContext<{
  season: Season
  setSeason: (s: Season) => void
}>({ season: '2027', setSeason: () => {} })

export function SeasonProvider({ children }: { children: React.ReactNode }) {
  const [season, setSeasonState] = useState<Season>(() => {
    const stored = localStorage.getItem('active-season')
    return (SEASONS as readonly string[]).includes(stored ?? '') ? (stored as Season) : '2027'
  })

  const setSeason = (s: Season) => {
    localStorage.setItem('active-season', s)
    setSeasonState(s)
  }

  return (
    <SeasonContext.Provider value={{ season, setSeason }}>
      {children}
    </SeasonContext.Provider>
  )
}

export const useSeason = () => useContext(SeasonContext)
